import React from "react";
import ParagraphTag from "../reusebale/Paragraph"
import HeadingTag from "../reusebale/heading";

const WelcomeHeader = (props) => {

    const { content, classes, subheading } = props;

  return (
    <div className="flex w-full">
        <div className="">
          <ParagraphTag
            content={`${content} `}
            classes="text-black/40 font-popinsMedium text-sm"
          />
          <HeadingTag
            title={subheading}
            classes="font-popinsSemiBold text-black text-2xl mt-[-4px]"
          />
        </div>
    </div>
  );
}

export default WelcomeHeader;
